import { render, staticRenderFns } from "./MarkerEditMenu.vue?vue&type=template&id=36931c45&scoped=true&"
import script from "./MarkerEditMenu.vue?vue&type=script&lang=js&"
export * from "./MarkerEditMenu.vue?vue&type=script&lang=js&"
import style0 from "./MarkerEditMenu.vue?vue&type=style&index=0&id=36931c45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36931c45",
  null
  
)

export default component.exports